import { useState } from 'react';
import { Checkbox } from './Checkbox/Checkbox';
import { Radio } from './Radio/Radio';
import { Link } from './Link/Link';
import clsx from 'clsx';

export function Facet({
    items,
    name,
    facetId,
    type,
    collapsible,
    initialCollapsed,
    onFacetChange,
    resourcedTexts,
}) {
    const [collapsed, setCollapsed] = useState(initialCollapsed);

    return (
        <div className={clsx('sfr-facet', collapsed && 'sfr-facet--collapsed')}>
            <button
                type="button"
                disabled={!collapsible}
                onClick={() => setCollapsed(!collapsed)}
                className="sfr-facet__toggle-trigger"
            >
                <span className="sfr-facet__title">{name}</span>
                {collapsible && (
                    <span className="visually-hidden">
                        {collapsed ? resourcedTexts.showFacetItems : resourcedTexts.hideFacetItems}
                    </span>
                )}
            </button>

            <div className="sfr-facet__list">
                <ul>
                    {items.map((facetItem) => {
                        if (!facetItem.visible) return null;
                        const facetItemId = facetId + '_' + facetItem.itemId;

                        switch (type) {
                            case 'checkbox':
                                return (
                                    <li key={facetItemId} className="sfr-facet__item">
                                        <Checkbox
                                            facetId={facetId}
                                            facetItem={facetItem}
                                            onFacetChange={onFacetChange}
                                        />
                                    </li>
                                );

                            case 'radio':
                                return (
                                    <li key={facetItemId} className="sfr-facet__item">
                                        <Radio
                                            facetId={facetId}
                                            facetItem={facetItem}
                                            onFacetChange={onFacetChange}
                                        />
                                    </li>
                                );

                            case 'link':
                                return (
                                    <li key={facetItemId} className="sfr-facet__item sfr-facet__item--link">
                                        <Link facetItem={facetItem} />
                                    </li>
                                );
                        }
                    })}
                </ul>
            </div>
        </div>
    );
}
